import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import AuthLayout from "src/components/navigation/publicNavbar";

const SignIn = lazy(
  () => import("src/screens/outerScreens/signin/signInScreen")
);
const HomeScreen = lazy(() => import("src/screens/outerScreens/home/home"));
const AboutUsScreen = lazy(() => import("src/screens/outerScreens/aboutUs/aboutUs"));
const BlogsScreen = lazy(() => import("src/screens/outerScreens/blogs/blogs"));
const CareerScreen = lazy(() => import("src/screens/outerScreens/career/career"));
const ContactUsScreen = lazy(() => import("src/screens/outerScreens/contactUs/contactUs"));

const PrivacyPolicyScreen = lazy(() => import("src/screens/outerScreens/privacyPolicy/privacyPolicy"));
const TermsAndConditionsScreen = lazy(() => import("src/screens/outerScreens/termsAndConditions/termsAndConditions"));
const ReturnPolicyScreen = lazy(() => import("src/screens/outerScreens/returnPolicy/returnPolicy"));


const ServicesScreen = lazy(() => import("src/screens/outerScreens/services/servicesScreen"));

const PricingScreen = lazy(() => import("src/screens/outerScreens/pricing/pricingScreen"));

const CartScreen = lazy(() => import("src/screens/outerScreens/cart/cartScreen"));

const CheckoutScreen = lazy(() => import("src/screens/outerScreens/checkOut/checkOutScreen"));
const OrderCompletedScreen = lazy(() => import("src/screens/outerScreens/orderCompleted/orderCompletedScreen"));
const EmptyCartScreen = lazy(() => import("src/screens/outerScreens/emptyCart/emptyCartScreen"));
const ProductDetailsScreen = lazy(() => import("src/screens/outerScreens/productDetails/productDetailsScreen"));
const ShopScreen = lazy(() => import("src/screens/outerScreens/shop/shopScreen"));
const WishListScreen = lazy(() => import("src/screens/outerScreens/wishList/wishListScreen"));
const ShoppingCartScreen = lazy(() => import("src/screens/outerScreens/shoppingCart/shoppingCartScreen"));
const TrackOrderScreen = lazy(() => import("src/screens/outerScreens/trackOrder/trackOrderScreen"));
const TrackOrderStatusScreen = lazy(() => import("src/screens/outerScreens/trackOrderStatus/trackOrderStatusScreen"));
const FaqsScreen = lazy(() => import("src/screens/outerScreens/faqs/faqs"));
const ShippingPolicyScreen = lazy(() => import("src/screens/outerScreens/shippingPolicy/shippingPolicy"));
const CustomerAccountScreen = lazy(() => import("src/screens/outerScreens/customerAccount/customerAccountScreen"));
const OrderHistoryScreen = lazy(() => import("src/screens/outerScreens/orderHistory/orderHistoryScreen"));
const AccountSettingsScreen = lazy(() => import("src/screens/outerScreens/accountSettings/accountSettingsScreen"));
const PersonalDetailsScreen = lazy(() => import("src/screens/outerScreens/personalDetails/personalDetailsScreen"));
const OrdersScreen = lazy(() => import("src/screens/outerScreens/orders/ordersScreen"));
const ManageAddressScreen = lazy(() => import("src/screens/outerScreens/manageAddress/manageAddressScreen"));
const PaymentMethodScreen = lazy(() => import("src/screens/outerScreens/paymentMethod/paymentMethodScreen"));
const PasswordManagerScreen = lazy(() => import("src/screens/outerScreens/passwordManager/passwordManagerScreen"));
const LogoutScreen = lazy(() => import("src/screens/outerScreens/logout/logoutScreen"));
const GeneralInformationScreen = lazy(() => import("src/screens/outerScreens/faqs/generalInformationScreen"));
const OrderingAndShippingScreen = lazy(() => import("src/screens/outerScreens/faqs/orderingAndShippingScreen"));
const ReturnsAndExchangesScreen = lazy(() => import("src/screens/outerScreens/faqs/ReturnsAndExchangesScreen"));
const PaymentsAndDiscountsScreen = lazy(() => import("src/screens/outerScreens/faqs/PaymentsAndDiscountsScreen"));
const AccountAndProfileScreen = lazy(() => import("src/screens/outerScreens/faqs/AccountAndProfileScreen"));
const AdminSignInOuter = lazy(() => import("src/screens/outerScreens/adminSigninOuter/adminSignInOuterScreen"));
const GalleryScreen = lazy(() => import("src/screens/outerScreens/gallery/galleryScreen"));
const PromotionalPartnerScreen = lazy(() => import("src/screens/outerScreens/promotional_partner/promotionalPartnerScreen"));
const NewArrivalsScreen = lazy(() => import("src/screens/outerScreens/new_arrivals/newArrivalsScreen"));

const AuthRoute: React.FC = () => {
  return (
    <AuthLayout>
      <Suspense>
        <Routes>
          <Route path="/signin" element={<SignIn />} />
          <Route path="/home" element={<HomeScreen />} />
          <Route path="/AboutUs" element={<AboutUsScreen />} />
          <Route path="/Blogs" element={<BlogsScreen />} />
          <Route path="/Career" element={<CareerScreen />} />
          <Route path="/ContactUs" element={<ContactUsScreen />} />
          
          <Route path="/PrivacyPolicy" element={<PrivacyPolicyScreen />} />
          <Route path="/TermsAndConditions" element={<TermsAndConditionsScreen />} />
          <Route path="/ReturnPolicy" element={<ReturnPolicyScreen />} />
          <Route path="/ShippingPolicy" element={<ShippingPolicyScreen />} />

          <Route path="/services" element={<ServicesScreen />} />
          <Route path="/pricing" element={<PricingScreen />} />
          <Route path="/cart" element={<CartScreen />} />
          <Route path="/checkout" element={<CheckoutScreen />} />
          <Route path="/OrderCompleted" element={<OrderCompletedScreen />} />
          <Route path="/emptycart" element={<EmptyCartScreen />} />
          <Route path="/productDetails" element={<ProductDetailsScreen />} />
          <Route path="/Shop" element={<ShopScreen />} />
          <Route path="/WishList" element={<WishListScreen />} />
          <Route path="/" element={<HomeScreen />} />
          <Route path="/ShoppingCart" element={<ShoppingCartScreen />} />
          <Route path="/TrackOrder" element={<TrackOrderScreen />} />
          <Route path="/TrackOrderStatus" element={<TrackOrderStatusScreen />} />
          <Route path="/Faqs" element={<FaqsScreen />} />
          <Route path="/MyAccount" element={<CustomerAccountScreen />} />
          <Route path="/OrderHistory" element={<OrderHistoryScreen />} />
          <Route path="/AccountSettings" element={<AccountSettingsScreen />} />
          <Route path="/PersonalDetails" element={<PersonalDetailsScreen />} />
          <Route path="/Orders" element={<OrdersScreen />} />
          <Route path="/ManageAddress" element={<ManageAddressScreen />} />
          <Route path="/PaymentMethod" element={<PaymentMethodScreen />} />
          <Route path="/PasswordManager" element={<PasswordManagerScreen />} />
          <Route path="/Logout" element={<LogoutScreen />} />
          <Route path="/GeneralInformation" element={<GeneralInformationScreen />} />
          <Route path="/OrderingAndShipping" element={<OrderingAndShippingScreen />} />
          <Route path="/ReturnsAndExchanges" element={<ReturnsAndExchangesScreen />} />
          <Route path="/PaymentsAndDiscounts" element={<PaymentsAndDiscountsScreen />} />
          <Route path="/AccountAndProfile" element={<AccountAndProfileScreen />} />
          <Route path="/Admin" element={<AdminSignInOuter />} />
          <Route path="/Gallery" element={<GalleryScreen />} />
          <Route path="/PromotionalPartner" element={<PromotionalPartnerScreen />} />
          <Route path="/NewArrivals" element={<NewArrivalsScreen />} />
        </Routes>
      </Suspense>
    </AuthLayout>
  );
};

export default AuthRoute;
